var $39ab1deee77acc45$exports = {};
const $39ab1deee77acc45$var$spaceHolder = document.querySelectorAll('.space-holder');
const $39ab1deee77acc45$var$horizontal = document.querySelectorAll('.horizontal');
const $39ab1deee77acc45$var$container = document.querySelectorAll('.containerCustom');
const $39ab1deee77acc45$var$stickyCustom = document.querySelectorAll('.stickyCustom');
function $39ab1deee77acc45$var$calcDynamicHeight(ref) {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const objectWidth = ref.scrollWidth;
    return objectWidth - vw + vh;
}
$39ab1deee77acc45$var$container.forEach(function(current, i) {
    $39ab1deee77acc45$var$spaceHolder[i].style.height = `${$39ab1deee77acc45$var$calcDynamicHeight($39ab1deee77acc45$var$horizontal[i])}px`;
    window.addEventListener('scroll', ()=>{
        $39ab1deee77acc45$var$horizontal[i].style.transform = `translateX(-${$39ab1deee77acc45$var$stickyCustom[i].offsetTop}px)`;
    });
    window.addEventListener('resize', ()=>{
        $39ab1deee77acc45$var$spaceHolder[i].style.height = `${$39ab1deee77acc45$var$calcDynamicHeight($39ab1deee77acc45$var$horizontal[i])}px`;
    });
});
// =======for accordion =======
let $39ab1deee77acc45$var$label = document.querySelectorAll(".box");
let $39ab1deee77acc45$var$activeIndex;
$39ab1deee77acc45$var$label.forEach((e, i)=>{
    e.addEventListener("click", ()=>{
        $39ab1deee77acc45$var$removeClass();
        if (!($39ab1deee77acc45$var$activeIndex === i)) {
            e.classList.toggle("active");
            $39ab1deee77acc45$var$activeIndex = i;
        } else $39ab1deee77acc45$var$activeIndex = null;
    });
});
function $39ab1deee77acc45$var$removeClass() {
    $39ab1deee77acc45$var$label.forEach((e)=>{
        e.classList.remove("active");
    });
}


//# sourceMappingURL=amazon-web-services.c7af92e5.js.map
